import React from 'react';
import PasswordResetConfirmForm from '../components/auth/PasswordResetConfirmForm';

const PasswordResetConfirmPage: React.FC = () => {
  return <PasswordResetConfirmForm />;
};

export default PasswordResetConfirmPage; 